import { useEffect, useState } from 'react';
import { loadMasters, masterEntry, masterLabel, masterOptions, mastersLoaded, onMastersChange } from '../services/masterService';

/** Re-renders the component once master data has loaded (and after every refresh). */
export function useMasters() {
  const [, setVersion] = useState(0);
  useEffect(() => {
    const off = onMastersChange(() => setVersion((v) => v + 1));
    loadMasters().catch(() => {});
    return off;
  }, []);
  return { ready: mastersLoaded(), options: masterOptions, label: masterLabel, entry: masterEntry };
}
